import { PublisherConfigurationResponse } from 'components/common/types/Publisher.types';
import multiPublisherRequest from 'modules/api/multiPublisherRequest';
import { getPublisherConfiguration } from 'modules/api/publisher';
import { getResellerMediaOwners } from 'modules/api/reseller';
import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { getIsReseller } from 'store/publisher/selectors';
import { changeUnderlyingMediaOwners, createUnderlyingMediaOwners, updateResellerState } from 'store/reseller/reducer';
import { getResellerDealMediaOwners } from 'store/reseller/selectors';

export const useResellerMediaOwners = (): void => {
  const dispatch = useDispatch();
  const { environmentId } = useSelector((state: RootState) => state.environment);
  const resellerMediaOwners = useSelector(getResellerDealMediaOwners);
  const isReseller = useSelector(getIsReseller);

  useEffect(() => {
    const getMediaOwners = async (): Promise<void> => {
      try {
        const result = await getResellerMediaOwners(environmentId, {});
        const parsedMediaOwners = JSON.parse(result.applicationConfiguration?.mediaOwners || '');
        dispatch(createUnderlyingMediaOwners(parsedMediaOwners));

        const publisherInfo = (await multiPublisherRequest(
          environmentId,
          parsedMediaOwners,
          getPublisherConfiguration as unknown as (...args: unknown[]) => Promise<unknown[]>,
          {
            cancelFunctions: {},
          },
        )) as PublisherConfigurationResponse[];

        dispatch(changeUnderlyingMediaOwners(publisherInfo));

        dispatch(
          updateResellerState({
            exclusiveDsps: result.applicationConfiguration?.exclusiveDsps?.replace(/\s+/g, '').split(',') || [],
            isInternalPublisher: result.applicationConfiguration?.isInternalPublisher === 'true' || false,
          }),
        );
      } catch (error) {
        dispatch(updateResellerState({ underlyingMediaOwners: {}, exclusiveDsps: [] }));
      }
    };

    if (isReseller && environmentId && resellerMediaOwners?.length === 0) {
      getMediaOwners();
    }
  }, [environmentId, isReseller]);
};
